import Box from '@eversports/klimt-primitives/legacy/Box'
import Link from '@eversports/klimt-primitives/legacy/Link'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Svg from '@eversports/klimt-primitives/legacy/Svg'

import NotificationsIcon from '../../../static/notifications.svg'
import Routes from '../../App.routes'
import { useIntl } from '../../localization/react'
import UnreadNotificationCount from '../UnreadNotificationsCount'

import { ColorContrast } from './Header.types'
import { NotificationsUserItem } from './UserMenu/UserMenuItems'
import UserMenuLink from './UserMenu/UserMenuLink'

interface Props {
  colorContrast?: ColorContrast
}

export const NotificationsButton = ({ colorContrast = ColorContrast.NORMAL }: Props) => {
  const intl = useIntl()

  return (
    <Link to={Routes.NOTIFICATIONS} ariaLabel={intl.notificationsAriaLabel()}>
      <Stack direction="row" alignItems="center" position="relative" sx={{ flexShrink: 0 }} gap={2}>
        <Svg
          src={NotificationsIcon}
          width={20}
          height={20}
          color={colorContrast === ColorContrast.NORMAL ? 'midnight' : 'white'}
        />
        <UnreadNotificationCount colorContrast={colorContrast} variant="dot" />
      </Stack>
    </Link>
  )
}

export const NotificationsUserMenuLink = () => {
  return (
    <Box sx={{ '&:hover': { backgroundColor: 'lightgray' } }}>
      <UserMenuLink userItem={NotificationsUserItem} />
    </Box>
  )
}
